/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import C4DMegaMenuRightNavigation from './megamenu-right-navigation';
import styles from './masthead.scss';

const { stablePrefix: c4dPrefix } = settings;

/**
 * MegaMenu left navigation (highlighted) section.
 *
 * @element c4d-megamenu-left-navigation
 */
@customElement(`${c4dPrefix}-megamenu-left-navigation`)
class C4DMegaMenuLeftNavigation extends C4DMegaMenuRightNavigation {
  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader

  static get onlyChildClassName() {
    return '';
  }

  static get stableSelector() {
    return `${c4dPrefix}--masthead__megamenu-left-navigation`;
  }
}

export default C4DMegaMenuLeftNavigation;
